module.exports = __webpack_public_path__ + "img/head_guarantee_499.3c6147a5.png";